export default "__VITE_ASSET__BDFQLy5i__"